import { http } from "../api/http";
import Utils from "../utils";

export const runbookStepService = {
  get,
  addBlank,
  addForLoopEndLoop,
  addAfter,
  addFalse,
  addBefore,
  addTrue,
  update,
  remove,
  getAllActions,
};

async function get(requestParameters) {
  let url = `/runbookstep?${Utils.objectToQueryString(requestParameters)}`;

  return await http.get(url).then((response) => {
    return response;
  });
}

async function addBlank(requestBody) {
  let url = `/runbookstep/addblank`;

  return await http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function addForLoopEndLoop(requestBody) {
  let url = `/runbookstep/addforloopendloop`;

  return await http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function addAfter(requestBody) {
  let url = `/runbookstep/addafter`;

  return await http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function addBefore(requestBody) {
  let url = `/runbookstep/addbefore`;

  return await http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function addTrue(requestBody) {
  let url = `/runbookstep/addtrue`;

  return await http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function addFalse(requestBody) {
  let url = `/runbookstep/addfalse`;

  return await http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function update(requestBody) {
  let url = `/runbookstep/update`;

  return await http.patch(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function remove(requestParameters) {
  let url = `/runbookstep/delete?${Utils.objectToQueryString(
    requestParameters
  )}`;

  return await http.delete(url).then((response) => {
    return response;
  });
}

async function getAllActions() {
  let url = "/runbookstep/getallactions";

  return await http.get(url).then((response) => {
    return response;
  });
}
